import React from 'react';
import tw from 'tailwind-styled-components';
import { Link } from 'gatsby';
import { Disclosure, Transition } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { navigation } from '../util/constants';
import { Button } from './shared/Buttons';
import TangoLogo from '../images/svg/TangoLogo.svg';
import { useScrollPosition } from '../hooks';


const StyledDisclosure = tw(Disclosure)`
  backdrop-blur
  bg-teal-20/30
  fixed
  top-0
  left-0
  right-0
  z-20
  w-full
  transition-colors
  ${ ({ scrollposition}) => scrollposition ? 'bg-white shadow-sm' : '' }
`;

const NavContainer = tw.div`
  max-w-screen-2xl
  h-20
  mx-5
  lg:mx-10
  3xl:mx-auto
`;


const NavigationItem = tw(Link)`
  flex
  font-sans
  font-regular
  items-center
  leading-normal
  not-italic
  py-2
  px-6
  text-base
  tracking-normal
  transition-all
  hover:text-blue-140
  ${
    props => props.active ?
    'font-medium text-blue-100 after:content-[" "] after:relative after:flex after:w-1 after:h-1 after:rounded-full after:bg-green-100 after:top-4 after:self-center after:left-[calc(-50%+2px)]' :
    'font-normal text-blue-80'
  }
`;


const Navbar = ({ location }) => {
  const isCurrentPathActive = path => location.pathname === path;
  const scrollPosition = useScrollPosition();

  return (
    <StyledDisclosure as="nav" scrollposition={scrollPosition} >
      {({ open }) => (
        <NavContainer>
          <div className="flex flex-row items-center h-full w-full justify-end">
            <Link to="/" className="flex-auto">
              <img src={TangoLogo} alt="Tango Logo" className="w-36 md:w-40"/>
            </Link>
            <div className="flex justify-end">
              <div className="flex gap-x-3 items-center md:gap-x-6">
                <div className="hidden lg:flex">
                  {
                    navigation.map((item) => (
                      <NavigationItem
                        key={item.name}
                        to={item.href}
                        target={item.target ? item.target : undefined}
                        active={isCurrentPathActive(item.href) ? "true" : undefined}
                      >
                        {item.name}
                      </NavigationItem>
                    ))
                  }
                </div>
                <div className="flex lg:hidden flex-col">
                  <Disclosure.Button className="inline-flex items-center justify-center p-2.5 rounded-md hover:bg-green-10">
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </Disclosure.Button>
                  <Transition
                      show={open}
                      enter="transition-opacity duration-75"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="transition-opacity duration-150"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <Disclosure.Panel className="lg:hidden fixed right-[182px]">
                        <div className="px-4 pt-2 pb-3 space-y-1 bg-white rounded-md">
                          {
                            navigation.map((item) => (
                              <NavigationItem
                                key={item.name}
                                to={item.href}
                                target={item.target ? item.target : undefined}
                                active={isCurrentPathActive(item.href) ? "true" : undefined}
                              >
                                {item.name}
                              </NavigationItem>
                            ))
                          }
                        </div>
                      </Disclosure.Panel>
                    </Transition>
                </div>
                <Button
                  size="small"
                  to='/contact'
                  type="secondary">
                  Get Started
                </Button>
              </div>
            </div>
          </div>
        </NavContainer>
      )}
    </StyledDisclosure>
  );
};

export default Navbar;
